<template>
  <div>
    <CCard class="pb-0">
      <CCardHeader class="pt-0 pb-0">
        <span class="card-header-title">Một cửa điện tử</span>
      </CCardHeader>
      <CWidgetDropdown class="mx-3 mt-2">
        <div style="height:170px">
          <iframe
            src="https://dichvucong.thainguyen.gov.vn/portal/synthesis/record_rate_on_time?owner_code=H55.17"
            style="max-width: 100%; height:100%; border : none;"
          ></iframe>
        </div>
      </CWidgetDropdown>
    </CCard>
  </div>
</template>
<script>
export default {
  created() {},
  methods: {},
  destroyed() {},
};
</script>
